import React from 'react';
import { Button, Grid, GridColumn, Heading, Icon, Modal, ModalCloser, ModalContent, Text } from '@teliaee/design-system';
import useStores from '../stores/UseStores';
import { observer } from 'mobx-react';
import { useIsTabletHook } from '../util/hooks/useIsMobile';

const PasskeyOfferRegisterResultModal = observer(() => {
  const {
    passkeyStore: { offerRegisterModalVisible, wasPasskeyRegisterSuccessful, registerErrorState, register, offerRegisterModalOnComplete, isWebAuthnInProgress },
    translateStore: { translate },
  } = useStores();
  const { isTablet } = useIsTabletHook();

  const handleClose = () => offerRegisterModalOnComplete();

  const handleRetry = () => register();

  const modalState = (() => {
    if (wasPasskeyRegisterSuccessful === null) {
      return null;
    }

    if (wasPasskeyRegisterSuccessful) {
      return {
        icon: '#check-round',
        iconClass: 'c-success-text',
        title: translate('passkey.offerRegister.result.success.title'),
        description: translate('passkey.offerRegister.result.success.text'),
        actions: (
          <ModalCloser>
            <Button variant="secondary" text={translate('passkey.offerRegister.result.close')} onClick={handleClose} />
          </ModalCloser>
        ),
      };
    }

    if (registerErrorState === null) {
      return null;
    }

    return {
      icon: '#alert',
      iconClass: 'c-error-text',
      title: translate(`passkey.offerRegister.result.error.${registerErrorState.errorType}.title`),
      description: translate(`passkey.offerRegister.result.error.${registerErrorState.errorType}.description`),
      actions: registerErrorState.canRetry ? (
        <Button
          disabled={isWebAuthnInProgress}
          variant="secondary"
          text={translate('passkey.offerRegister.result.retry')}
          iconLeft="#refresh"
          onClick={handleRetry}
        />
      ) : (
        <ModalCloser>
          <Button variant="secondary" text={translate('passkey.offerRegister.result.close')} onClick={handleClose} />
        </ModalCloser>
      ),
    };
  })();

  if (modalState === null) {
    return null;
  }

  return (
    <Modal isOpen={offerRegisterModalVisible} isFullHeight={!isTablet} onClose={offerRegisterModalOnComplete}>
      <ModalContent>
        <Grid horizontalGutter="none" verticalGutter="smedium">
          <GridColumn width={['xs-12']}>
            <Grid align={['center-xs']} gutter="none">
              <GridColumn width={['min-xs']}>
                <Icon size="xxl" modifiers={modalState.icon} className={modalState.iconClass} verticalAlign="middle" />
              </GridColumn>
            </Grid>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Heading level={1} className="h3 text-center">
              {modalState.title}
            </Heading>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Text className="text-center" element="p">
              {modalState.description}
            </Text>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Grid align={['center-xs']} gutter="none">
              <GridColumn width={['min-xs']}>{modalState.actions}</GridColumn>
            </Grid>
          </GridColumn>
        </Grid>
      </ModalContent>
    </Modal>
  );
});

export default PasskeyOfferRegisterResultModal;
